var _defs, _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _g3, _g4, _path7, _ellipse, _path8, _path9, _path10, _ellipse2, _path11, _g5, _ellipse3, _path12, _path13, _path14, _g6, _g7, _g8, _g9, _path15, _path16, _path17, _path18, _path19, _path20, _g10, _g11, _g12, _g13, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g14, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSumX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 118,
    viewBox: "0 0 166 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.691,
    y1: 0.085,
    x2: 0.112,
    y2: 1.249,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.637,
    y1: 0.163,
    x2: 0.362,
    y2: 0.845,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 118,
    transform: "translate(246 419.866)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.481,1398.335a5.754,5.754,0,0,0,1.262-2.4c.187-3.07.909-8.794-1.095-11.354-.342-.437-2.672.55-3.247.329a6.575,6.575,0,0,1-3.872-.046c-4.967-1.5-3.257-11.97-11.827-9.3-6.277,1.955-9.4,6.749-14.393-1.644s-21.442-18.592-26.032-7.151c-2.634,6.566,7.007,9.966,7.987,16.718.931,6.416,5.675,8.946,12.73,8.3s5.87,3.432,7.536,8.989c2,6.675,11.053,1.838,15.041-.751C773.781,1397.936,783.366,1394.793,786.481,1398.335Z",
    transform: "translate(-726.822 -1361.661)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M772.131,777.866q5.368-3.937,10.614-8.126c.085.022-2.056-8.843-7.765-11-11.218-4.087-9.071-14.4-9.408-19.634-.213-7.519-4.252-13.59-10.707-10.2-7.216,3.621-13.327-7.321-16.422-18.614-1.142-5.708-8.665-9.294-14.176-8.052-5.678,1.144-9.343,7.117-6.616,18.249,2.611,13.186,14.385,15.59,20.117,19.795,5.635,4.124.143,12.927,8.3,14.861,6.961,1.873,14.7,1.733,14.773,8.8C760.822,770.985,763.337,775.363,772.131,777.866Z",
    transform: "translate(-716.73 -701.995)",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.302,
    y1: 0.298,
    x2: 0.81,
    y2: 0.84,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.978,
    y1: 0.047,
    x2: 0.263,
    y2: 0.702,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ebeff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.453,
    y1: 1.209,
    x2: 0.493,
    y2: 0.605,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#26264f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444b8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 0.341,
    y1: 0.939,
    x2: 0.642,
    y2: -0.276,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.384,
    y1: 1.047,
    x2: 0.649,
    y2: -0.416,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0.475,
    y1: 1.004,
    x2: 0.576,
    y2: -0.995,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -0.641,
    y1: 0.986,
    x2: 0.67,
    y2: 0.427,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -0.788,
    y1: 1.049,
    x2: 0.523,
    y2: 0.49,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -0.573,
    y1: 10.265,
    x2: 0.045,
    y2: 4.833,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0.546,
    y1: 0.061,
    x2: 0.39,
    y2: 1.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142,
    stopColor: "#fec144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#fdb946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#f99c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#f8924f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8924f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0.881,
    y1: 0.067,
    x2: 0.433,
    y2: 0.559,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0.451,
    y1: -0.115,
    x2: 0.688,
    y2: 2.232,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 0.473,
    y1: 0.366,
    x2: 1.052,
    y2: 2.183,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: -0.012,
    y1: 0.026,
    x2: 1.499,
    y2: 1.304,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.974,
    y1: -0.105,
    x2: 0.276,
    y2: 0.797,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0.593,
    y1: -0.143,
    x2: 0.053,
    y2: 3.782,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: -22.51,
    y1: -27.177,
    x2: -23.303,
    y2: -25.241,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: -20.767,
    y1: -16.978,
    x2: -21.56,
    y2: -15.042,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 8.365,
    y1: -2.306,
    x2: 8.545,
    y2: 2.731,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 30.236,
    y1: 1.262,
    x2: 30.114,
    y2: -4.955,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 12.948,
    y1: -1.418,
    x2: 13.234,
    y2: 1.534,
    xlinkHref: "#am"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 21.555,
    y1: 1.444,
    x2: 21.468,
    y2: -2.938,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 4.565,
    y1: 0.506,
    x2: 5.566,
    y2: 0.506,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3e4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 4.822,
    y1: 0.506,
    x2: 5.896,
    y2: 0.506,
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 2.256,
    y1: 0.507,
    x2: 3.253,
    y2: 0.507,
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0.799,
    y1: -0.049,
    x2: 0.226,
    y2: 1.009,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 0.549,
    y1: 0.204,
    x2: 0.293,
    y2: 3.433,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 24.57,
    y1: 9.511,
    x2: 23.82,
    y2: 7.837,
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 0.44,
    y1: -0.008,
    x2: 0.938,
    y2: 4.489,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 58.528,
    y1: -43.185,
    x2: 59.408,
    y2: -43.185,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0.819,
    y1: 0.139,
    x2: -0.341,
    y2: 1.435,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: -10.944,
    y1: 2.397,
    x2: -11.447,
    y2: 1.853,
    xlinkHref: "#bb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: -12.415,
    y1: 1.669,
    x2: -11.691,
    y2: 2.437,
    xlinkHref: "#bb"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: -117.833,
    y1: -34.727,
    x2: -117.628,
    y2: -36.459,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: -0.526,
    y1: -0.018,
    x2: 1.792,
    y2: 1.129,
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: -1.535,
    y1: -0.119,
    x2: 2.33,
    y2: 1.124,
    xlinkHref: "#aq"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 0.936,
    y1: -0.09,
    x2: -1.257,
    y2: 2.877,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-246 -419.866)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.57 423.68)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.124,463.284c-5.129,6.654.885,17.442-6.726,22.446-7.409,4.871-16.511-3.113-23.493,1.08-10.358,6.22-8.466,34.684,6.678,52.369,4.554,5.318,8.36,7.388,10.045,13.4,3.619,12.915-9.1,20.6-6.68,26.986,5.45,14.383,89.266,26.452,122.9-16.774,15.707-20.188,18.057-49.34,4.023-71.481C592.51,451.3,522.634,448.353,511.124,463.284Z",
    transform: "translate(-474.41 -455)",
    fill: "#f4f7fa",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.927 12.157)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.497 32.47)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M786.481,1398.335a5.754,5.754,0,0,0,1.262-2.4c.187-3.07.909-8.794-1.095-11.354-.342-.437-2.672.55-3.247.329a6.575,6.575,0,0,1-3.872-.046c-4.967-1.5-3.257-11.97-11.827-9.3-6.277,1.955-9.4,6.749-14.393-1.644s-21.442-18.592-26.032-7.151c-2.634,6.566,7.007,9.966,7.987,16.718.931,6.416,5.675,8.946,12.73,8.3s5.87,3.432,7.536,8.989c2,6.675,11.053,1.838,15.041-.751C773.781,1397.936,783.366,1394.793,786.481,1398.335Z",
    transform: "translate(-726.822 -1361.661)",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.899 -2.591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M796.146,1412.511a57.4,57.4,0,0,1-25.084-5.829,68.823,68.823,0,0,1-25.969-22.5l.136-.1a68.652,68.652,0,0,0,25.906,22.448,56.786,56.786,0,0,0,33.5,5.166l.025.164A56.194,56.194,0,0,1,796.146,1412.511Z",
    transform: "translate(-745.093 -1380.389)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.06,1966.192l-.133-.1c3.793-5.008,11.971-10.733,18.23-12.764l.051.158C1329.977,1955.508,1321.836,1961.207,1318.06,1966.192Z",
    transform: "translate(-1289.731 -1921.614)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.17,1631.923c-3.424-.443-6.487-2.594-9.105-6.392a38.921,38.921,0,0,1-4.855-10.606l.159-.049a38.752,38.752,0,0,0,4.833,10.56c2.59,3.758,5.615,5.885,8.99,6.322Z",
    transform: "translate(-1540.054 -1599.821)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.822,1823.809l-.088-.141c4.055-2.54,10.217-5.324,16.544-4.172l-.03.164C918.973,1818.516,912.852,1821.285,908.822,1823.809Z",
    transform: "translate(-900.679 -1794.115)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.8,1326.362c-1.963-2.438-5.158-7.934-4.5-17.344l.166.012c-.654,9.353,2.515,14.809,4.463,17.228Z",
    transform: "translate(-894.482 -1309.018)",
    fill: "#fcfdfe"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M772.131,777.866q5.368-3.937,10.614-8.126c.085.022-2.056-8.843-7.765-11-11.218-4.087-9.071-14.4-9.408-19.634-.213-7.519-4.252-13.59-10.707-10.2-7.216,3.621-13.327-7.321-16.422-18.614-1.142-5.708-8.665-9.294-14.176-8.052-5.678,1.144-9.343,7.117-6.616,18.249,2.611,13.186,14.385,15.59,20.117,19.795,5.635,4.124.143,12.927,8.3,14.861,6.961,1.873,14.7,1.733,14.773,8.8C760.822,770.985,763.337,775.363,772.131,777.866Z",
    transform: "translate(-716.73 -701.995)",
    fill: "url(#b)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.207 -3.393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.818,710.067a252.968,252.968,0,0,0-23.965-28.6c-2-2.25-4.071-4.474-6.076-6.625-5.38-5.77-10.942-11.736-15.173-18.4a48.933,48.933,0,0,1-7.878-23.367l.332-.023a48.61,48.61,0,0,0,7.827,23.212c4.214,6.639,9.766,12.594,15.135,18.352,2.007,2.152,4.082,4.378,6.075,6.624A250.252,250.252,0,0,1,923.12,709.93l-.155.061Z",
    transform: "translate(-860.988 -633.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.933,1055.217c-6.186-2.359-14.059-6.2-18.288-8.271-1.772-.866-3.172-1.549-3.347-1.584a.147.147,0,0,0,.107-.03l-.2-.267c.132-.1.136-.1,3.584,1.582,4.225,2.064,12.089,5.906,18.261,8.259Z",
    transform: "translate(-692.207 -1024.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.433,767.488c-2.342-10.215,1.725-17.653,2.857-18.947.069-.078.134-.141.228-.134l-.031.331a.137.137,0,0,0,.1-.023,15.8,15.8,0,0,0-2.5,5.3,26.146,26.146,0,0,0-.323,13.4Z",
    transform: "translate(-1016.909 -742.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.93,1217.611c-2.683-4.692-3.737-10.728-3.131-17.941a58.188,58.188,0,0,1,2.256-11.652c.057-.192.106-.358.112-.391l.329.045a4.575,4.575,0,0,1-.123.441,57.891,57.891,0,0,0-2.244,11.585c-.6,7.144.44,13.115,3.089,17.748Z",
    transform: "translate(-1518.839 -1160.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.923,1662.213l-.18-.09.039-.2a22.478,22.478,0,0,1,5.968-1.862c3.121-.546,7.672-.671,11.626,1.837l-.178.281c-7.436-4.717-17.126-.044-17.217.008l-.082-.143-.005,0Z",
    transform: "translate(-1170.958 -1609.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892.322,1869.291c-.994-2.159-1.756-6.335.26-13.973.045-.171.084-.32.089-.351l.146.021.161-.1c.043.07.043.07-.074.513-1.991,7.543-1.25,11.64-.279,13.749Z",
    transform: "translate(-1832.293 -1794.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.4,2014.7c-2.741-3.259-9.85-2.926-12.779-2.632-.128.013-.21.021-.24.022l-.01-.332c.027,0,.1-.009.217-.02,8.627-.867,11.89,1.35,13.067,2.749Z",
    transform: "translate(-1549.017 -1943.687)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.713 6.118)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.441,580.914l-47.6-1.611a1.884,1.884,0,0,0-1.972,1.883v86.459a1.833,1.833,0,0,0,1.972,1.838l47.6-2.707a1.946,1.946,0,0,0,1.781-1.951v-82A1.892,1.892,0,0,0,1371.441,580.914Z",
    transform: "translate(-1321.873 -579.301)",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.912,644.757c-.809-9.886,5.263-13.966,2.948-22.923-2.863-11.071-13.872-11.546-17.622-22.4-1.437-4.16-2-10.448,2.108-19.6l-15.5-.525a1.884,1.884,0,0,0-1.972,1.883v86.459a1.833,1.833,0,0,0,1.972,1.838l42.439-2.413C1355.487,658.709,1352.41,650.833,1351.912,644.757Z",
    transform: "translate(-1321.873 -579.301)",
    fill: "#d8dee8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.9,604.167l-47.6-1.556a.775.775,0,0,0-.809.774v86.358a.754.754,0,0,0,.809.755l47.6-2.652a.8.8,0,0,0,.732-.8V604.952A.778.778,0,0,0,1393.9,604.167Z",
    transform: "translate(-1344.336 -601.464)",
    opacity: 0.3,
    fill: "url(#i)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.464 68.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1564.568,1962.424l-28.88,1.041a1.29,1.29,0,0,0-1.235,1.278h0a1.179,1.179,0,0,0,1.235,1.186l28.88-1.113a1.234,1.234,0,0,0,1.161-1.239h0A1.128,1.128,0,0,0,1564.568,1962.424Z",
    transform: "translate(-1534.453 -1962.424)",
    opacity: 0.6,
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.568,2048.958l-28.88,1.169a1.3,1.3,0,0,0-1.235,1.283h0a1.173,1.173,0,0,0,1.235,1.18l28.88-1.242a1.24,1.24,0,0,0,1.161-1.244h0A1.122,1.122,0,0,0,1564.568,2048.958Z",
    transform: "translate(-1534.453 -2044.698)",
    opacity: 0.6,
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.568,2135.491l-28.88,1.3a1.3,1.3,0,0,0-1.235,1.289h0a1.167,1.167,0,0,0,1.235,1.175l28.88-1.37a1.248,1.248,0,0,0,1.161-1.25h0A1.116,1.116,0,0,0,1564.568,2135.491Z",
    transform: "translate(-1534.453 -2126.972)",
    opacity: 0.6,
    fill: "url(#j)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.464 5.749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1549.592,696.522l-14.527-.411a.591.591,0,0,0-.612.593h0a.632.632,0,0,0,.612.627l14.527.393a.578.578,0,0,0,.593-.585h0A.618.618,0,0,0,1549.592,696.522Z",
    transform: "translate(-1534.453 -696.11)",
    opacity: 0.6,
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.592,740.644l-14.527-.379a.592.592,0,0,0-.612.594h0a.63.63,0,0,0,.612.626l14.527.361a.579.579,0,0,0,.593-.586h0A.616.616,0,0,0,1549.592,740.644Z",
    transform: "translate(-1534.453 -738.091)",
    opacity: 0.6,
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.592,784.767l-14.527-.347a.594.594,0,0,0-.612.6h0a.628.628,0,0,0,.612.624l14.527.329a.581.581,0,0,0,.593-.587h0A.614.614,0,0,0,1549.592,784.767Z",
    transform: "translate(-1534.453 -780.073)",
    opacity: 0.6,
    fill: "url(#j)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1376.728,666.989c-.809-9.885,5.262-13.965,2.947-22.92-2.862-11.07-13.869-11.544-17.617-22.4-1.377-3.988-1.955-9.932,1.625-18.489l-15.015-.491a.775.775,0,0,0-.809.774V689.81a.754.754,0,0,0,.809.755l41.141-2.292C1380.052,680.292,1377.2,672.813,1376.728,666.989Z",
    transform: "translate(-1346.579 -601.537)",
    fill: "#fff",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.335 20.131)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.263,878.984c0-8.283-7.052-15-15.751-15s-15.751,6.715-15.751,15a14.774,14.774,0,0,0,6.584,12.2,6.187,6.187,0,0,1,2.717,5.1v1.148a4.515,4.515,0,0,0,4.515,4.515h3.87a4.515,4.515,0,0,0,4.515-4.515v-1.148a6.187,6.187,0,0,1,2.717-5.1A14.774,14.774,0,0,0,1061.263,878.984Z",
    transform: "translate(-1029.761 -863.986)",
    fill: "#f4f7fa",
    opacity: 0.75
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.494,
    cy: 1.85,
    rx: 3.494,
    ry: 1.85,
    transform: "translate(12.257 42.799)",
    fill: "url(#p)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.447,1703.959v1.889a1.659,1.659,0,0,0,.94,1.5,8.852,8.852,0,0,0,4.067.752,9.129,9.129,0,0,0,3.245-.566,1.687,1.687,0,0,0,1.032-1.562v-1.045Z",
    transform: "translate(-1244.339 -1662.614)",
    fill: "url(#q)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1255.447,1705.614a1.829,1.829,0,0,0,.489.342c.9.429,6.784,1.386,8.2.853a1.909,1.909,0,0,0,.5-.274,1.712,1.712,0,0,0,.1-.563v-1.045l-9.284-.967Z",
    transform: "translate(-1244.339 -1662.614)",
    opacity: 0.3,
    fill: "url(#r)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.931,1677.753a.886.886,0,0,0-.978.881v.054a1.862,1.862,0,0,0,1.055,1.683c.9.428,6.784,1.386,8.2.852a1.715,1.715,0,0,0,1.157-1.645v-.043a.886.886,0,0,0-.794-.882Z",
    transform: "translate(-1233.41 -1637.694)",
    fill: "url(#s)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1256.468,1678.654l-8.644-.9a.885.885,0,0,0-.828.39,1.85,1.85,0,0,0,.905.95c.9.428,7.034,1.511,8.2.96a2.028,2.028,0,0,0,1-1.016A.884.884,0,0,0,1256.468,1678.654Z",
    transform: "translate(-1236.303 -1637.694)",
    opacity: 0.3,
    fill: "url(#r)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.593,1615.668a.64.64,0,0,0-.64.64v1.479a1.862,1.862,0,0,0,1.055,1.683c.9.428,7.034,1.511,8.2.96a1.952,1.952,0,0,0,1.157-1.753v-2.369a.64.64,0,0,0-.64-.64Z",
    transform: "translate(-1233.41 -1578.669)",
    fill: "url(#r)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.079,
    cy: 1.201,
    rx: 5.079,
    ry: 1.201,
    transform: "translate(10.672 36.259)",
    fill: "url(#v)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.263,878.984c0-8.283-7.052-15-15.751-15s-15.751,6.715-15.751,15a14.774,14.774,0,0,0,6.584,12.2,6.187,6.187,0,0,1,2.717,5.1v1.148a4.515,4.515,0,0,0,4.515,4.515h3.87a4.515,4.515,0,0,0,4.515-4.515v-1.148a6.187,6.187,0,0,1,2.717-5.1A14.774,14.774,0,0,0,1061.263,878.984Z",
    transform: "translate(-1029.761 -863.986)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.717,
    cy: 0.879,
    rx: 3.717,
    ry: 0.879,
    transform: "translate(12.034 35.634)",
    fill: "#f4f7fa",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.834 13.351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1273.126,1197.682a.215.215,0,0,1-.213-.187l-2.734-21.263a.215.215,0,0,1,.426-.055l2.734,21.262a.215.215,0,0,1-.186.24Z",
    transform: "translate(-1270.177 -1173.984)",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.43,1197.682l-.027,0a.215.215,0,0,1-.186-.24l2.734-21.262a.215.215,0,0,1,.426.055l-2.734,21.263A.215.215,0,0,1,1360.43,1197.682Z",
    transform: "translate(-1355.783 -1173.983)",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.236,1137.461a.215.215,0,0,1-.18-.1l-.755-1.145a.034.034,0,0,0-.031-.017.034.034,0,0,0-.029.018l-.5.834a.464.464,0,0,1-.786.019l-.684-1.026a.035.035,0,0,0-.03-.017.036.036,0,0,0-.029.016l-.6.869a.465.465,0,0,1-.381.2h0a.466.466,0,0,1-.381-.2l-.866-1.241a.04.04,0,0,0-.031-.016.034.034,0,0,0-.029.018l-.791,1.365a.215.215,0,1,1-.372-.215l.791-1.365a.464.464,0,0,1,.783-.033l.866,1.241a.034.034,0,0,0,.029.016h0a.034.034,0,0,0,.028-.016l.6-.869a.464.464,0,0,1,.769.007l.684,1.026c.008.011.019.021.031.017a.033.033,0,0,0,.029-.018l.5-.834a.464.464,0,0,1,.787-.017l.755,1.145a.215.215,0,0,1-.179.333Z",
    transform: "translate(-1277.362 -1135.229)",
    fill: "url(#y)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1045.8,937.926c.337-5.781,10.082-7.134,10.041-12.3-.026-3.18-3.9-5.541-4.725-6.014-6.093-3.485-13.593.539-15.141-2.309a2.661,2.661,0,0,1-.1-1.921,4.121,4.121,0,0,1,1.031-1.849,14.6,14.6,0,0,0-.556,24.756,6.187,6.187,0,0,1,2.717,5.1v1.148a4.515,4.515,0,0,0,4.515,4.515h3.87a4.515,4.515,0,0,0,4.515-4.515v-.918a2.962,2.962,0,0,1-1.815.687C1047.819,944.3,1045.63,940.8,1045.8,937.926Z",
    transform: "translate(-1029.761 -911.099)",
    opacity: 0.3,
    fill: "url(#z)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.554,
    cy: 13.071,
    rx: 13.554,
    ry: 13.071,
    transform: "translate(2.449 2.511)",
    opacity: 0.2,
    fill: "url(#aa)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.621 61.511)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.562)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M943.229,1705.926l-36.928-1.25a1.461,1.461,0,0,0-1.53,1.461v67.08a1.422,1.422,0,0,0,1.53,1.426l36.928-2.1a1.51,1.51,0,0,0,1.382-1.513v-63.622A1.468,1.468,0,0,0,943.229,1705.926Z",
    transform: "translate(-904.771 -1704.675)",
    fill: "url(#ab)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M928.077,1755.459c-.628-7.67,4.083-10.836,2.287-17.785-2.221-8.589-10.763-8.958-13.672-17.381-1.115-3.228-1.555-8.107,1.636-15.21l-12.027-.407a1.461,1.461,0,0,0-1.53,1.461v67.08a1.422,1.422,0,0,0,1.53,1.426l32.927-1.872C930.851,1766.283,928.463,1760.173,928.077,1755.459Z",
    transform: "translate(-904.771 -1704.675)",
    fill: "#d8dee8"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M960.656,1723.967l-36.928-1.207a.6.6,0,0,0-.628.6v67a.585.585,0,0,0,.628.586l36.928-2.057a.621.621,0,0,0,.568-.622v-63.693A.6.6,0,0,0,960.656,1723.967Z",
    transform: "translate(-922.199 -1721.869)",
    fill: "url(#i)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.118 52.82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1093.067,2777.779l-22.407.807a1,1,0,0,0-.958.991h0a.915.915,0,0,0,.958.92l22.407-.863a.958.958,0,0,0,.9-.961h0A.875.875,0,0,0,1093.067,2777.779Z",
    transform: "translate(-1069.702 -2777.778)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.067,2844.917l-22.407.907a1.007,1.007,0,0,0-.958,1h0a.91.91,0,0,0,.958.916l22.407-.963a.963.963,0,0,0,.9-.965h0A.871.871,0,0,0,1093.067,2844.917Z",
    transform: "translate(-1069.702 -2841.612)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.067,2912.054l-22.407,1.007a1.012,1.012,0,0,0-.958,1h0a.905.905,0,0,0,.958.911l22.407-1.063a.968.968,0,0,0,.9-.969h0A.866.866,0,0,0,1093.067,2912.054Z",
    transform: "translate(-1069.702 -2905.444)",
    fill: "#d8dee8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.118 4.461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1081.448,1795.621l-11.271-.319a.458.458,0,0,0-.475.46h0a.49.49,0,0,0,.475.486l11.271.305a.449.449,0,0,0,.46-.454h0A.479.479,0,0,0,1081.448,1795.621Z",
    transform: "translate(-1069.702 -1795.301)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.448,1829.854l-11.271-.294a.46.46,0,0,0-.475.461h0a.489.489,0,0,0,.475.485l11.271.28a.449.449,0,0,0,.46-.455h0A.478.478,0,0,0,1081.448,1829.854Z",
    transform: "translate(-1069.702 -1827.873)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.448,1864.087l-11.271-.27a.461.461,0,0,0-.475.462h0a.488.488,0,0,0,.475.484l11.271.255a.451.451,0,0,0,.46-.455h0A.477.477,0,0,0,1081.448,1864.087Z",
    transform: "translate(-1069.702 -1860.445)",
    fill: "#d8dee8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.078 12.053)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1095.3,2050.409a4.824,4.824,0,0,1,3.706-2.551l.112-6.841a11.575,11.575,0,0,0-10.279,6.982Z",
    transform: "translate(-1087.859 -2041.017)",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.352,2295.03a4.843,4.843,0,0,1-4.7,4.039,4.724,4.724,0,0,1-1.963-.4l-3.585,5.893a11.344,11.344,0,0,0,5.548,1.324,11.644,11.644,0,0,0,11.307-10.6Z",
    transform: "translate(-1187.938 -2282.527)",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.94,2221.071l3.6-5.9a4.864,4.864,0,0,1-1.776-3.772,4.958,4.958,0,0,1,.117-1.073l-6.469-2.4a11.83,11.83,0,0,0-.524,3.493A11.665,11.665,0,0,0,1073.94,2221.071Z",
    transform: "translate(-1068.884 -2199.711)",
    fill: "url(#af)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1321.421,1960.92a4.827,4.827,0,0,1,4.035,4.348l10.929.432s0-.01,0-.015a16.106,16.106,0,0,0-14.779-16.134Z",
    transform: "translate(-1321.421 -1949.551)",
    fill: "url(#ag)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M947.331,1772.708c-.628-7.669,4.083-10.835,2.286-17.783-2.22-8.589-10.76-8.957-13.668-17.379-1.068-3.094-1.517-7.706,1.261-14.345l-11.65-.381a.6.6,0,0,0-.628.6v66.994a.585.585,0,0,0,.628.586l31.919-1.778C949.91,1783.028,947.7,1777.226,947.331,1772.708Z",
    transform: "translate(-923.94 -1721.926)",
    fill: "#fff",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M769.734,1937.05l-17.872-.178a.731.731,0,0,1-.732-.719v-6.8a.7.7,0,0,1,.732-.694l15.558.371a.712.712,0,0,1,.693.708v5.842Z",
    transform: "translate(-751.13 -1928.661)",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.545,1965.9l-11.835-.231v-.815l11.835.247Z",
    transform: "translate(-802.072 -1963.077)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.545,1998.983l-11.835-.2v-.815l11.835.214Z",
    transform: "translate(-802.072 -1994.559)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.545,2032.062l-11.835-.165v-.815l11.835.182Z",
    transform: "translate(-802.072 -2026.041)",
    fill: "#fff",
    opacity: 0.67
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.819 41.026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1277.326,2539.434l15.967-.343a.746.746,0,0,1,.752.762v7.434a.8.8,0,0,1-.752.8l-16.829.567a.762.762,0,0,1-.788-.771v-9.718Z",
    transform: "translate(-1275.675 -2538.169)",
    opacity: 0.3,
    fill: "url(#ai)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.415,2684.333l12.8-.383v.9l-12.8.4Z",
    transform: "translate(-1330.573 -2676.775)",
    fill: "#fff",
    opacity: 0.67
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.415,2647.792l12.8-.352v.9l-12.8.368Z",
    transform: "translate(-1330.573 -2642.062)",
    fill: "#fff",
    opacity: 0.67
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.415,2611.251l12.8-.32v.9l-12.8.336Z",
    transform: "translate(-1330.573 -2607.35)",
    fill: "#fff",
    opacity: 0.67
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.061 20.907)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1845.1,881.435l-49.625-1.68a1.964,1.964,0,0,0-2.056,1.963v90.144a1.911,1.911,0,0,0,2.056,1.916l49.625-2.822a2.029,2.029,0,0,0,1.857-2.034v-85.5A1.973,1.973,0,0,0,1845.1,881.435Z",
    transform: "translate(-1793.422 -879.754)",
    fill: "url(#ab)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1824.742,948c-.844-10.307,5.488-14.562,3.073-23.9-2.985-11.543-14.463-12.038-18.372-23.357-1.5-4.337-2.089-10.894,2.2-20.44l-16.162-.547a1.964,1.964,0,0,0-2.056,1.963v90.144a1.911,1.911,0,0,0,2.056,1.916l44.249-2.516C1828.469,962.547,1825.261,954.335,1824.742,948Z",
    transform: "translate(-1793.422 -879.754)",
    fill: "#d8dee8"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1868.522,905.68l-49.625-1.622a.808.808,0,0,0-.844.807V994.9a.786.786,0,0,0,.844.787l49.625-2.765a.834.834,0,0,0,.764-.836V906.5A.811.811,0,0,0,1868.522,905.68Z",
    transform: "translate(-1816.841 -902.861)",
    fill: "url(#i)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.909 70.981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.461,2321.832l-30.111,1.085a1.345,1.345,0,0,0-1.288,1.332h0a1.229,1.229,0,0,0,1.288,1.236l30.111-1.16a1.286,1.286,0,0,0,1.21-1.292h0A1.176,1.176,0,0,0,2046.461,2321.832Z",
    transform: "translate(-2015.062 -2321.831)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.461,2412.053l-30.111,1.219a1.352,1.352,0,0,0-1.288,1.338h0a1.223,1.223,0,0,0,1.288,1.231l30.111-1.294a1.294,1.294,0,0,0,1.21-1.3h0A1.17,1.17,0,0,0,2046.461,2412.053Z",
    transform: "translate(-2015.062 -2407.612)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.461,2502.277l-30.111,1.353a1.359,1.359,0,0,0-1.288,1.344h0a1.216,1.216,0,0,0,1.288,1.225l30.111-1.429a1.3,1.3,0,0,0,1.21-1.3h0A1.163,1.163,0,0,0,2046.461,2502.277Z",
    transform: "translate(-2015.062 -2493.394)",
    fill: "#d8dee8"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.909 5.995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2030.847,1001.971l-15.147-.429a.616.616,0,0,0-.638.618h0a.659.659,0,0,0,.638.654l15.147.41a.6.6,0,0,0,.618-.61h0A.644.644,0,0,0,2030.847,1001.971Z",
    transform: "translate(-2015.062 -1001.542)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030.847,1047.974l-15.147-.4a.618.618,0,0,0-.638.62h0a.657.657,0,0,0,.638.652l15.147.377a.6.6,0,0,0,.618-.611h0A.642.642,0,0,0,2030.847,1047.974Z",
    transform: "translate(-2015.062 -1045.312)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030.847,1093.978l-15.147-.362a.619.619,0,0,0-.638.621h0a.655.655,0,0,0,.638.651l15.147.343a.605.605,0,0,0,.618-.612h0A.64.64,0,0,0,2030.847,1093.978Z",
    transform: "translate(-2015.062 -1089.083)",
    fill: "#d8dee8"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.909 35.233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.442,1001.971l-30.112-.429c-.7-.01-1.268.267-1.268.618h0c0,.351.568.644,1.268.654l30.112.41c.679.009,1.229-.264,1.229-.61h0C2047.671,1002.269,2047.122,1001.981,2046.442,1001.971Z",
    transform: "translate(-2015.062 -1001.542)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.442,1047.974l-30.112-.4c-.7-.009-1.268.269-1.268.62h0c0,.352.568.644,1.268.652l30.112.377c.679.008,1.229-.265,1.229-.611h0C2047.671,1048.271,2047.122,1047.983,2046.442,1047.974Z",
    transform: "translate(-2015.062 -1045.312)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.442,1093.978l-30.112-.362c-.7-.008-1.268.27-1.268.621h0c0,.351.568.643,1.268.651l30.112.343c.679.008,1.229-.266,1.229-.612h0C2047.671,1094.273,2047.122,1093.986,2046.442,1093.978Z",
    transform: "translate(-2015.062 -1089.083)",
    fill: "#d8dee8"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.909 16.959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.442,1002.475l-30.112-.932a1.281,1.281,0,0,0-1.268,1.344h0a1.378,1.378,0,0,0,1.268,1.421l30.112.892a1.255,1.255,0,0,0,1.229-1.325h0A1.35,1.35,0,0,0,2046.442,1002.475Z",
    transform: "translate(-2015.062 -1001.542)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.442,1048.439l-30.112-.86a1.285,1.285,0,0,0-1.268,1.347h0a1.375,1.375,0,0,0,1.268,1.418l30.112.819a1.259,1.259,0,0,0,1.229-1.328h0A1.346,1.346,0,0,0,2046.442,1048.439Z",
    transform: "translate(-2015.062 -1042.653)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.442,1094.4l-30.112-.787a1.288,1.288,0,0,0-1.268,1.35h0a1.37,1.37,0,0,0,1.268,1.415l30.112.747a1.262,1.262,0,0,0,1.229-1.331h0A1.342,1.342,0,0,0,2046.442,1094.4Z",
    transform: "translate(-2015.062 -1083.764)",
    fill: "#d8dee8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1850.614,971.179c-.844-10.306,5.486-14.56,3.073-23.9-2.984-11.542-14.46-12.037-18.368-23.355-1.435-4.158-2.039-10.356,1.694-19.277l-15.655-.512a.808.808,0,0,0-.844.807v90.029a.786.786,0,0,0,.844.787l42.894-2.39C1854.08,985.049,1851.111,977.252,1850.614,971.179Z",
    transform: "translate(-1819.18 -902.937)",
    fill: "#fff",
    opacity: 0.35,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.534 55.132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2294.073,2001.534l21.458-.461a1,1,0,0,1,1.011,1.024v9.99a1.072,1.072,0,0,1-1.011,1.08l-22.616.762a1.024,1.024,0,0,1-1.06-1.036v-13.059Z",
    transform: "translate(-2291.855 -1999.835)",
    opacity: 0.3,
    fill: "url(#al)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2369.448,2196.256l17.2-.514v1.207l-17.2.535Z",
    transform: "translate(-2365.629 -2186.098)",
    fill: "#fff",
    opacity: 0.67
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2369.448,2147.15l17.2-.473v1.208l-17.2.494Z",
    transform: "translate(-2365.629 -2139.45)",
    fill: "#fff",
    opacity: 0.67
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2369.448,2098.046l17.2-.431v1.207l-17.2.452Z",
    transform: "translate(-2365.629 -2092.802)",
    fill: "#fff",
    opacity: 0.67
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.106 68.59)"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2269.316,3158.036a27.026,27.026,0,0,0-3.571,1.862c-.057.256,2.262-.091,3.209-.056s1.725-.247,1.639-.648-.421-1.409-.421-1.409Z",
    transform: "translate(-2218.678 -3093.34)",
    fill: "url(#am)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2335.631,3132.811l.218,1.583a1.241,1.241,0,0,0,.931-.038l.156-1.738Z",
    transform: "translate(-2285.125 -3069.412)",
    fill: "url(#an)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2623.3,3136.493l.411.656a.784.784,0,0,1,.1.614c-.142.547-.425,1.612-.549,1.889-.168.378-2.444.609-2.444.609s-.2-.285.268-.631.775-.4.941-.911a13.33,13.33,0,0,0,.273-1.95Z",
    transform: "translate(-2556.229 -3073.095)",
    fill: "url(#ao)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2637.516,3098.941a21.278,21.278,0,0,1,.886,2.336s.238.3.686-.146.2-.2.2-.2l-.09-2.183Z",
    transform: "translate(-2572.151 -3037.208)",
    fill: "url(#ap)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2292.488,2447.37c-.174,4.725-.169,9.857.116,15.341.321,6.174.949,11.88,1.737,17.052.288.008.591.009.907,0,.213-.007.42-.018.62-.032a39.3,39.3,0,0,0,1.293-4.172,40.087,40.087,0,0,0,.9-4.883c.665-5.353-.13-5.818.41-9.785.479-3.513,1.17-3.653,1.971-8.641.869-5.412.21-6.223-.109-6.515C2298.969,2444.49,2295.779,2445.348,2292.488,2447.37Z",
    transform: "translate(-2243.994 -2415.786)",
    fill: "url(#aq)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2311.39,2445.749c-1.3-1.187-4.262-.46-7.389,1.365,3.612,3.883,4.01,6.407,3.583,8.046-.484,1.853-1.966,2.389-1.956,4.414.013,2.488,2.26,3.142,2.219,5.774-.028,1.741-1.014,1.725-1.242,3.876-.27,2.544,1.022,3.418.609,5.3a5.092,5.092,0,0,1-2.145,2.963c.107.773.217,1.538.331,2.288.288.009.591.01.907,0q.32-.01.62-.032a39.225,39.225,0,0,0,1.294-4.172,40.087,40.087,0,0,0,.9-4.883c.665-5.353-.13-5.818.41-9.785.478-3.513,1.17-3.652,1.971-8.641C2312.368,2446.852,2311.71,2446.042,2311.39,2445.749Z",
    transform: "translate(-2255.052 -2415.801)",
    opacity: 0.3,
    fill: "url(#ar)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2340.084,2437.388a106.1,106.1,0,0,1,14.618,31.093,1.9,1.9,0,0,0,1.039.159,1.933,1.933,0,0,0,1.175-.639,30.57,30.57,0,0,0,.252-7.534,25.971,25.971,0,0,0-1.073-5.66c-.863-2.76-1.452-2.914-2.576-5.833-1.167-3.03-.888-3.788-2.007-7.581a50.1,50.1,0,0,0-2.5-6.649Z",
    transform: "translate(-2289.359 -2405.889)",
    fill: "url(#as)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2083.2,2038.609c.03,1.1,1.842,2.073,3.3,2.371,3.411.7,7.366-1.782,9.243-4.524.369-.538.779-1.191.877-1.141.223.114-1.828,3.484-2.717,7.316-.455,1.961-.335,2.879-1.186,4.184a1.285,1.285,0,0,0-.347.953c.209.876,2.212,1.1,3.6,1.261a32.03,32.03,0,0,0,4.188.131c2.165-.031,2.335-.144,2.83.1,1.506.739,1.4,2.51,2.537,2.746.952.2,1.918-.865,2.224-1.2,1.591-1.751,1.506-3.863,1.789-5.993a31.682,31.682,0,0,1,5.979-13.812c.8-1.042,1.353-1.589,1.388-2.557.1-2.842-4.4-5.979-8.149-6.339a28.154,28.154,0,0,0-4.592.095c-.689.065-1.423.161-2.212.3a18.066,18.066,0,0,0-4.6,1.188c-5.473,2.5-4.278,8.078-10.2,11.932C2085.119,2036.939,2083.174,2037.454,2083.2,2038.609Z",
    transform: "translate(-2045.124 -2013.502)",
    fill: "url(#at)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2474.957,1963.293a8.15,8.15,0,0,0,.776,2.245c.489.844,2.51,1.146,2.932,1.293s-.635.88-1.759,1.146-4.411.44-5.054.086.418-.462,1.192-.868,1.031-2.059.792-2.761S2474.957,1963.293,2474.957,1963.293Z",
    transform: "translate(-2414.452 -1957.642)",
    fill: "url(#au)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.55 2.719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2479.566,1906.279c-.816-.583-1.042-2.159-.589-2.513.13-.1.253-.055,2.094.683.914.367,1.363.562,1.511.965a1.281,1.281,0,0,1-.024.841,3.223,3.223,0,0,1-.375.624c-.2.284-.184.275-.245.358a4.5,4.5,0,0,1-.941.921,3.126,3.126,0,0,0-.15-.521,2.755,2.755,0,0,0-.333-.62A3.115,3.115,0,0,0,2479.566,1906.279Z",
    transform: "translate(-2478.747 -1903.727)",
    fill: "url(#av)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2494.3,1948.7a1.694,1.694,0,0,1-1.522.687c-.885-.1-.927-2.092-.343-2.49a1.123,1.123,0,0,1,.881-.075c.179.059.238.137.533.228.273.084.352.056.432.13.1.092.167.31-.032.885a.482.482,0,0,1,.524-.147.3.3,0,0,1,.113.12C2495,1948.271,2494.778,1948.552,2494.3,1948.7Z",
    transform: "translate(-2491.39 -1944.648)",
    fill: "url(#aw)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2098.351,2246.325c2.473-.557,3.459-.539,4.682-1.524,2.036-1.641,2.342-4.138,3.526-4.108.559.015,1.013.586,1.337,1.145l-.894,1.4c0-.018-.005-.031-.015-.037-.1-.051-.508.6-.877,1.141-1.877,2.742-5.832,5.221-9.243,4.525a5.933,5.933,0,0,1-2.765-1.344A42.316,42.316,0,0,1,2098.351,2246.325Z",
    transform: "translate(-2055.485 -2221.388)",
    opacity: 0.3,
    fill: "url(#ax)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2030.462,2386.443a9.524,9.524,0,0,1-2.227-.495c-.832-.356-1.369.155-1.293.509s1.445.846,1.991.864S2030.462,2386.443,2030.462,2386.443Z",
    transform: "translate(-1991.624 -2359.38)",
    fill: "url(#ay)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2572.985,2076.762c1.5.134,4.871.195,7.257-2.012,3.971-3.674,2-10.668.619-13.675a17.122,17.122,0,0,0-5.641-6.552c-1.9-1.456-3.063-2.344-4.459-2.145-3.612.515-6.114,7.917-4.131,10.037.649.694,1.292.3,3.17.9.612.195,5.178,1.649,5.973,5.012.556,2.354-.86,5.11-3.382,6.961Z",
    transform: "translate(-2504.089 -2042.316)",
    fill: "url(#az)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2277,2212.488c1.7-1.072,1.948-2.158,3.847-2.893,2.468-.954,3.653.258,4.877-.72,1.456-1.164.167-3.192,1.257-6.712.185-.6,1.59-5.135,4.813-5.713a4.344,4.344,0,0,1,4.253,1.58c.6,1,.041,1.74.769,2.84s1.6.83,2.525,1.748a5.193,5.193,0,0,1,.369,6.264c-.62.81-1.426,1.13-2.942,1.733a14.264,14.264,0,0,1-2.528.743c1.856-1.782,2.82-4.079,2.345-6.086-.5-2.1-2.457-3.451-4.012-4.221a29.326,29.326,0,0,0-3.251,9.519c-.282,2.13-.2,4.242-1.788,5.993-.306.337-1.272,1.4-2.224,1.2-1.133-.236-1.031-2.007-2.537-2.746-.494-.243-.665-.13-2.83-.1a31.986,31.986,0,0,1-4.188-.131c-1.236-.14-2.954-.337-3.467-.995A9.032,9.032,0,0,0,2277,2212.488Z",
    transform: "translate(-2224.896 -2179.262)",
    opacity: 0.3,
    fill: "url(#ax)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2015.64,2330.379l.175-.513a1.522,1.522,0,0,0-1.021-1.948l-33.02-10.059-1.006,3.41,32.854,10.119A1.63,1.63,0,0,0,2015.64,2330.379Z",
    transform: "translate(-1947.728 -2294.756)",
    fill: "url(#bb)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.128,1862.359c2.525-9.974,12.418-15.985,22.2-13.168,9.964,2.869,15.668,13.664,12.641,23.841a17.823,17.823,0,0,1-22.554,12.232C1326.121,1882.251,1320.661,1872.106,1323.128,1862.359Zm31.969,9.792a16.031,16.031,0,0,0-10.592-19.957,14.993,14.993,0,0,0-18.668,10.994,16.086,16.086,0,0,0,10.344,19.3A14.967,14.967,0,0,0,1355.1,1872.151Z",
    transform: "translate(-1321.896 -1848.495)",
    fill: "url(#bb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1981.773,2317.858l4.21,1.282a4.375,4.375,0,0,0,1.416,2.581c2.127,1.763,4.966-.16,8.928,1.907,1.988,1.037,1.61,1.7,3.474,2.421,3.081,1.2,4.491-.461,7.217.628,2.758,1.1,3.03,3.483,4.594,3.4.669-.037,1.53-.523,2.491-2.369l.691.21a1.522,1.522,0,0,1,1.021,1.948l-.175.513a1.63,1.63,0,0,1-2.02,1.009l-32.854-10.119Z",
    transform: "translate(-1947.728 -2294.756)",
    fill: "#d8dee8",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.057,1949.381a15.49,15.49,0,0,0,19.581-10.683,16.589,16.589,0,0,0-10.966-20.666,15.518,15.518,0,0,0-19.315,11.39A16.649,16.649,0,0,0,1367.057,1949.381Z",
    transform: "translate(-1353.553 -1914.025)",
    fill: "#fff",
    opacity: 0.56
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.135,1879.737c2.525-9.974,12.418-15.985,22.2-13.168,9.964,2.869,15.668,13.664,12.641,23.841a17.823,17.823,0,0,1-22.554,12.232C1313.127,1899.629,1307.668,1889.484,1310.135,1879.737Zm31.969,9.792a16.031,16.031,0,0,0-10.592-19.957,14.993,14.993,0,0,0-18.668,10.994,16.086,16.086,0,0,0,10.344,19.3A14.967,14.967,0,0,0,1342.1,1889.529Z",
    transform: "translate(-1309.543 -1865.018)",
    fill: "url(#bd)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.111,1901.268a16.847,16.847,0,0,1,20.953-12.4c9.38,2.711,14.755,12.876,11.915,22.465a16.814,16.814,0,0,1-21.266,11.564A18.074,18.074,0,0,1,1330.111,1901.268Zm31.012,9.5a16.03,16.03,0,0,0-10.592-19.957,14.993,14.993,0,0,0-18.668,10.994,16.087,16.087,0,0,0,10.344,19.3A14.967,14.967,0,0,0,1361.124,1910.768Z",
    transform: "translate(-1328.562 -1886.256)",
    fill: "url(#be)"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2641.819,2516.408l-.334-.829a1.707,1.707,0,0,1-.992-.287,1.291,1.291,0,0,0-.8-.192c-.126.035-.6.014-.059.272s.537.449.311.661a3.92,3.92,0,0,1-1.392.69c-.308.022.25.5.561.561a1.923,1.923,0,0,0,1.454-.234C2640.8,2516.914,2641.819,2516.408,2641.819,2516.408Z",
    transform: "translate(-2573.05 -2482.279)",
    fill: "url(#bf)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.394 10.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1957.193,675.806a1.195,1.195,0,0,0,1.078-2.124c-.028-.014-.057-.026-.086-.038a6.83,6.83,0,0,0,.227-.979c.031,0,.062,0,.094,0a1.246,1.246,0,0,0,1.1-1.268,1.055,1.055,0,0,0-1.143-1.069c-.032,0-.064.008-.1.014a6.288,6.288,0,0,0-.265-.935c.028-.017.057-.034.084-.053a1.246,1.246,0,0,0,.377-1.633,1.055,1.055,0,0,0-1.537-.292c-.027.019-.053.039-.078.06a5.574,5.574,0,0,0-.686-.64c.017-.029.035-.058.05-.088.3-.587.687-1.227.141-1.494-1.263-.617-1.8-.089-2.1.5-.015.03-.029.061-.042.092a5.587,5.587,0,0,0-.922-.176c0-.033,0-.065,0-.1-.013-.645.179-.995-.442-1.007-1.353-.026-1.809.561-1.8,1.206,0,.034,0,.067.007.1a6.286,6.286,0,0,0-.911.338c-.014-.029-.029-.057-.046-.085a1.055,1.055,0,0,0-1.537-.291,1.246,1.246,0,0,0-.378,1.633c.016.027.034.053.053.078a6.837,6.837,0,0,0-.656.761c-.026-.016-.053-.033-.081-.047a1.195,1.195,0,0,0-1.078,2.124c.028.014.057.026.085.038a6.914,6.914,0,0,0-.228.979c-.031,0-.062,0-.094,0a1.246,1.246,0,0,0-1.1,1.268,1.056,1.056,0,0,0,1.142,1.069c.032,0,.064-.008.1-.014a6.277,6.277,0,0,0,.265.935c-.029.017-.057.034-.084.053a1.246,1.246,0,0,0-.378,1.633,1.546,1.546,0,0,0,1.909.408c.027-.019-.319-.156-.294-.177a5.59,5.59,0,0,0,.686.64c-.017.029-.034.058-.05.088a1.1,1.1,0,1,0,1.962,1c.016-.03.029-.061.042-.092a5.575,5.575,0,0,0,.921.176c0,.033,0,.065,0,.1a1.055,1.055,0,0,0,1.142,1.069,1.246,1.246,0,0,0,1.1-1.268c0-.034,0-.067-.007-.1a6.3,6.3,0,0,0,.911-.338c.014.029.029.057.046.085a1.056,1.056,0,0,0,1.537.292,1.246,1.246,0,0,0,.377-1.633c-.016-.027-.034-.053-.053-.078a6.88,6.88,0,0,0,.656-.761C1957.138,675.775,1957.165,675.791,1957.193,675.806Zm-6.753.086a4.338,4.338,0,1,1,5.519-2.048A4.169,4.169,0,0,1,1950.44,675.891Z",
    transform: "translate(-1945.193 -664.572)",
    fill: "url(#bg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.879,696.138a1.246,1.246,0,0,0,1.1-1.268,1.055,1.055,0,0,0-1.143-1.069c-.032,0-.064.008-.1.014a6.263,6.263,0,0,0-.265-.935c.029-.017.057-.034.084-.053.529-.37,1.183-1.265.81-1.761-.708-.941-1.441-.534-1.97-.163-.027.019-.052.039-.078.06a5.6,5.6,0,0,0-.686-.64c.018-.029.034-.058.05-.088a1.231,1.231,0,0,0,.069-.97q-.766,1.348-1.509,2.709a4.233,4.233,0,0,1,1.088,5.347,4.332,4.332,0,0,1-4.1,2.441c-.072.186-.143.374-.219.559-.209.5-.447.993-.685,1.483q.225.042.45.066c0,.033,0,.065,0,.1.013.646.4,1.194,1.525,1.135.62-.033.726-.688.713-1.334,0-.034,0-.067-.007-.1a6.292,6.292,0,0,0,.911-.338c.014.029.028.057.045.085a1.611,1.611,0,0,0,1.96.387c.529-.37.275-1.2-.045-1.728-.017-.027-.035-.053-.053-.078a6.862,6.862,0,0,0,.656-.761c.026.017.053.033.081.047a1.195,1.195,0,0,0,1.079-2.124c-.028-.014-.057-.026-.085-.038a6.833,6.833,0,0,0,.228-.979C2069.817,696.142,2069.848,696.141,2069.879,696.138Z",
    transform: "translate(-2056.565 -688.049)",
    fill: "url(#bh)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.029,675.885a1.195,1.195,0,0,0,1.079-2.124c-.028-.014-.057-.026-.085-.038a6.878,6.878,0,0,0,.227-.979c.031,0,.062,0,.094,0a1.246,1.246,0,0,0,1.1-1.268,1.056,1.056,0,0,0-1.143-1.069c-.032,0-.064.008-.1.014a6.307,6.307,0,0,0-.265-.935c.029-.017.057-.034.084-.053a1.246,1.246,0,0,0,.378-1.633,1.055,1.055,0,0,0-1.537-.292c-.027.019-.053.039-.078.06a5.6,5.6,0,0,0-.686-.64c.017-.029.034-.058.05-.088a1.1,1.1,0,1,0-1.962-1c-.015.03-.028.061-.041.092a5.578,5.578,0,0,0-.921-.176c0-.033,0-.065,0-.1a1.055,1.055,0,0,0-1.142-1.069,1.246,1.246,0,0,0-1.1,1.268c0,.034,0,.067.007.1a6.313,6.313,0,0,0-.911.338c-.014-.029-.029-.057-.046-.085a1.055,1.055,0,0,0-1.537-.292,1.246,1.246,0,0,0-.377,1.633c.016.027.034.053.053.078a6.838,6.838,0,0,0-.656.761c-.026-.016-.053-.032-.081-.047a1.195,1.195,0,0,0-1.078,2.124c.028.014.057.026.085.038a6.848,6.848,0,0,0-.228.979c-.031,0-.062,0-.094,0a1.247,1.247,0,0,0-1.1,1.269,1.056,1.056,0,0,0,1.143,1.069c.032,0,.064-.008.1-.014a6.29,6.29,0,0,0,.265.935c-.029.017-.057.034-.084.053a1.246,1.246,0,0,0-.378,1.633,1.055,1.055,0,0,0,1.537.292c.027-.019.053-.039.078-.06a5.589,5.589,0,0,0,.685.64c-.017.029-.034.057-.05.088a1.1,1.1,0,1,0,1.962,1c.015-.03.029-.061.042-.092a5.581,5.581,0,0,0,.921.176c0,.033,0,.065,0,.1a1.055,1.055,0,0,0,1.142,1.069,1.246,1.246,0,0,0,1.1-1.268c0-.034,0-.067-.007-.1a6.288,6.288,0,0,0,.911-.338c.014.029.028.057.045.085a1.055,1.055,0,0,0,1.537.292,1.247,1.247,0,0,0,.378-1.633c-.016-.027-.034-.053-.053-.078a6.859,6.859,0,0,0,.656-.761C1968.974,675.854,1969,675.871,1969.029,675.885Zm-6.752.086a4.338,4.338,0,1,1,5.519-2.048A4.169,4.169,0,0,1,1962.276,675.97Z",
    transform: "translate(-1956.446 -664.585)",
    fill: "url(#bi)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumX);
export default __webpack_public_path__ + "static/media/Sum X.b850d5f060ef86cd77d32f353c25fc5a.svg";
export { ForwardRef as ReactComponent };